import React from 'react';
import { LuX } from 'react-icons/lu';

import { Badge } from '@/components/ui/badge';
import { Button } from '@/components/ui/button';

interface FilterLabelProps {
    label: string;
    onRemove: () => void;
}

export const FilterLabel = ({ label, onRemove }: FilterLabelProps) => {
    return (
        <Badge variant="default" className="flex items-center gap-2">
            <span className="pb-0.5 text-center">{label}</span>
            <Button
                className="h-4 w-4"
                variant="ghost"
                size="icon"
                onClick={(e) => {
                    e.stopPropagation();
                    onRemove();
                }}
            >
                <LuX className="text-accent-foreground" />
            </Button>
        </Badge>
    );
};
